<label (click)="edicion ? input.click() : null" [ngClass]="{'lock': !edicion}">Adjuntar documento</label>

<input #input type="file" (change)="onSelectFile($event)" aria-label="input file" accept="image/png, image/jpeg, application/pdf">
<div class="infoFile ok">
    <p class="docName" [ngClass]="{'docError': (!control.valid && (control.dirty || control.touched)) || corrupted}">
        <ng-container *ngIf="file">
            {{file.name}} - {{file.size | fileSizeFormat:1 }}
        </ng-container>
    </p>
    <div class="statusOption">
        <img *ngIf="!corrupted && file && !(control?.errors?.fileExtension || false) && !(control?.errors?.fileSize || false)" src="assets/icons/icon-check.svg" alt="ok">
        <button *ngIf="isLoading" (click)="deleteItem();" class="icon-delete">
            <i><span>Delete</span></i>
        </button>

    </div>
</div>
<div class="upFile" *ngIf="control.valid">
    <div class="container-box" *ngIf="isLoading">
        <!-- <mat-progress-bar mode="indeterminate"></mat-progress-bar> -->
    </div>
    <!-- <div class="cancel" *ngIf="input.value">
        <button class="icon-cancel"><i><span class="cancelar">cancel</span></i></button>
    </div> -->
</div>
<ng-container *ngIf="(!control.valid && (control.dirty || control.touched)) || corrupted">
    <app-messages *ngIf="control?.errors?.fileExtension || false" class="mensaje-pj m-16 error" [message]="'El formato del documento que adjuntaste no es válido. Inténtalo nuevamente.'">

    </app-messages>
    <app-messages *ngIf="control?.errors?.fileSize || false" class="mensaje-pj m-16 error"
        message="El tamaño del documento supera los {{mb}}MB. Revisa que el documento adjunto cumpla con el tamaño máximo.">
    </app-messages>
    <app-messages *ngIf="corrupted" class="mensaje-pj m-16 error"
        message="El archivo que subiste es ilegible, por favor adjunta uno nuevo.">
    </app-messages>

</ng-container>
<p class="accepted-formats" *ngIf="edicion || !file">
  Subir archivos en formato <span class="uppercase">{{ acceptedFormats.join(', ') }}</span> y
    no debe pesar más de {{mb}} MB
</p>
